import { useEffect, useMemo, useState } from "react";
import style from "./index.module.less";
import { useSearchParams } from "react-router-dom";
import PageContainer from "@/component/pageContainer";
import { getCurrentUid } from "@/api/common";
import { orderDetail } from "./ajax";
import imageUrl from "@/assets//detailPage/infoRight@2x.png";
import { ApiResponse, Order } from "./type";
import copyImage from "@/assets/copy@1x.png";
import { Loading, Toast } from "@xp-design/mobile";
import { goToNativePage } from "@/utils/common";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { processOssImage } from "@/utils/image";

// 活动详情
const activityDetail = () => {
  const [searchParams] = useSearchParams();
  const hdFontVal = useMemo(
    () => searchParams.get("hdFontVal"),
    [searchParams],
  );
  // const selfActivityValue = useMemo(
  //   () => searchParams.get("selfActivityValue"),
  //   [searchParams]
  // );
  const [selfActivityValue, setSelfActivityValue] = useState<any>();
  const [list, setList] = useState<Order[]>([]);
  const getData = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      const res = (await orderDetail({
        uid,
        activityCode: searchParams.get("activityCode"),
        pageNo: 1,
        pageSize: -1,
      })) as ApiResponse;
      console.log("%c Line:22 🍷 res", "color:#93c0a4", res);
      setList(res.records[0]?.orderList || []);
      setSelfActivityValue(res.records[0].selfActivityValue || "");
    } catch (error) {
      console.log("%c Line:114 🥤 error", "color:#b03734", error);
    } finally {
      Loading.hide();
    }
  };
  const handleCopy = () => {
    Toast.show({
      content: "已复制到剪贴板",
    });
  };

  const seeDetail = (orderNo: string) => {
    //查看详情
    goToNativePage({
      mini: `/charging/pages/order-detail/index?orderNo=${orderNo}`,
      app: `xiaopeng://charging/manage?orderNo=${orderNo}`,
      browser: `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent(`xiaopeng://charging/manage?orderNo=${orderNo}`)}`,
    });
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <PageContainer title={`${hdFontVal}明细`}>
      <div className={style["activityDetail"]}>
        <div className={style["infoBox"]}>
          <div>
            <div className={style["label"]}>总{hdFontVal}</div>
            <div className={style["value"]}>{selfActivityValue}</div>
          </div>
          <img src={processOssImage(imageUrl)} alt="找不到图片" />
        </div>
        <div className={style["listBox"]}>
          {list.map((item, i) => (
            <div className={style["listInfoBox"]} key={`listInfoBox${i}`}>
              <div className={style["listInfoBox_title"]}>
                <div className={style["title"]}>{item.electricityName}</div>
                <div className={style["activityValue"]}>
                  +{item.activityValue}
                </div>
              </div>
              <div className={style["listInfoBox_orderNo"]}>
                <div className={style["orderNo"]}>订单号：{item.orderNo}</div>
                <CopyToClipboard text={item.orderNo} onCopy={handleCopy}>
                  <img src={processOssImage(copyImage)} alt="" />
                </CopyToClipboard>
              </div>
              <div className={style["listInfoBox_time"]}>
                <div className={style["time"]}>获得时间：{item.createTime}</div>
                <div style={{ lineHeight: "30px", height: "30px" }}>
                  <div
                    className={style["btn"]}
                    onClick={() => seeDetail(item.orderNo)}
                  >
                    查看详情
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageContainer>
  );
};

export default activityDetail;
